var noop=function(){};noop.noop=!0;export default noop;